import { useTheme } from '../context/ThemeContext';

const Loader = ({ 
  size = 'medium', 
  fullScreen = false, 
  overlay = false,
  text = ''
}) => {
  const { isDarkMode } = useTheme();
  
  const getBarSizeClass = () => {
    switch (size) {
      case 'small':
        return 'h-4 w-1 mx-0.5';
      case 'large':
        return 'h-12 w-2 mx-1';
      case 'medium':
      default:
        return 'h-8 w-1.5 mx-0.5';
    }
  };

  const baseColor = isDarkMode ? 'bg-violet-500' : 'bg-violet-600';
  
  // Add keyframes animation as a style tag in the component
  const keyframesStyle = `
    @keyframes pulse {
      0%, 100% {
        transform: scaleY(0.4);
        opacity: 0.3;
      }
      50% {
        transform: scaleY(1);
        opacity: 1;
      }
    }
  `;
  
  const loaderElement = (
    <div className="flex flex-col justify-center items-center">
      <style>{keyframesStyle}</style>
      <div className="flex items-end">
        {[0, 1, 2, 3, 4].map((i) => (
          <div 
            key={i}
            className={`${getBarSizeClass()} ${baseColor} rounded-full`}
            style={{
              animation: 'pulse 1.2s ease-in-out infinite',
              animationDelay: `${i * 0.15}s`,
              opacity: '0.3'
            }}
          />
        ))}
      </div>
      {text && (
        <p className={`mt-3 text-sm font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
          {text}
        </p>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 flex justify-center items-center z-50">
        {overlay && (
          <div className={`absolute inset-0 ${isDarkMode ? 'bg-gray-900' : 'bg-gray-100'} opacity-75`}></div>
        )}
        <div className="relative z-10">
          {loaderElement}
        </div>
      </div>
    );
  }

  // Default container with min height
  return (
    <div className="flex justify-center items-center w-full h-full min-h-[100px] p-4">
      {loaderElement}
    </div>
  );
};

export default Loader;
